import Button from '../../../../../../components/Button';
import styled from 'styled-components';

export const EditButtonStyled = styled(Button)`
  width: calc(var(--px) * 120);
  height: calc(var(--px) * 50);

  .icon-container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc(var(--apx) * 35);
    width: calc(var(--apx) * 35);
    margin-right: calc(var(--apx) * 10);
    border-radius: 100%;
    background-color: currentColor;
  }

  span {
    font-size: calc(var(--apx) * 16) !important;
    font-family: 'DINNextLTPro-Heavy';
  }

  .edit-card-icon {
    font-size: calc(var(--apx) * 20);
    color: white;
  }
`;
